export const VisualListSequenceModelEmits = {
    click: (_data: any, _ev: MouseEvent) => true,
};
